<template>
  <div class="container-fluid overflow-auto">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getDirectPushReturnPiece"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(exclusion_at)="row">
        {{ convertRocDate(row.item.exclusion_at) }}
      </template>

      <template #cell(dead_at)="row">
        {{ convertRocDate(row.item.dead_at) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="primary"
          size="sm"
          @click="billhandle(row.item, 'preview')"
          v-if="row.item.total_1 !== 0"
        >
          預覽帳單
        </b-button>

        <b-button
          variant="info"
          size="sm"
          @click="billhandle(row.item, 'download')"
          v-if="row.item.total_1 !== 0"
        >
          下載帳單
        </b-button>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :isIframePreviewPdf="false"
      :enableDownload="status.pdfEnableDownload"
      @handlerCompleted="billhandlerCompleted"
      @exportImg="data.previewImg = $event"
    >
      <template slot="pdf-content">
          <print-template :data="data.temp_table_data"></print-template>
      </template>
    </html-to-pdf>

    <!-- 預覽帳單 modal -->
    <preview-bill-modal
      v-model="status.previewBillModal"
      :img="data.previewImg" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import businessInfoApi from "@/models/API/businessInfoApi";
import { countNoNum, convertRocDate, getLocalUserInfo } from "@/models/HELPERS/common.js";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import PrintTemplate from '@/components/common/PrintTemplate/Bill';
import PreviewBillModal from "@/components/common/Modal/PreviewBillModal";

export default {
  name: 'pay',
  components: {
    BreadCrumb,
    TablesPage,
    HtmlToPdf,
    PrintTemplate,
    PreviewBillModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '直推', url: '', isActive: true },
          { name: '直推回歸件', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        name: '',
      },
      status: {
        isNew: false,
        resetDom: false,
        previewBillModal: false,
        pdfEnableDownload: false
      },
      data: {
        table_data: [],
        page: {},
        temp_table_data: {},
        info: {},
        previewImg: '',
        billMode: ''
      },
      tab: {
        items: [
          {
            label: '正常',
            value: 0
          },
          {
            label: '身故',
            value: 1
          },
          // {
          //   label: '停效',
          //   value: 2
          // },
          {
            label: '除會',
            value: 3
          },
          // {
          //   label: '墊繳',
          //   value: 4
          // },
        ],
        tabIndex: 0
      }

    }
  },
  watch: {
    'tab.tabIndex': {
      handler(newValue, oldValue) {
        this.getDirectPushReturnPiece();
      },
      immediate: false
    }
  },
  computed: {
    tableFields() {
      let table_fields = [
        {
          key: "no",
          label: "No",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "互助人姓名",
        },
        {
          key: "join_date",
          label: "入會日期"
        },
        {
          key: "exclusion_at",
          label: "失效日期"
        },
        {
          key: "dead_at",
          label: "身故日期"
        },
        {
          key: "seniority_month",
          label: "年資(月)"
        },
        {
          key: "total_0",
          label: "已繳金額"
        },
        {
          key: "pay_count",
          label: "繳費次數"
        },

      ]

      if (this.tab.tabIndex === 0) {
        table_fields.unshift({
          key: "function",
          label: "列印"
        })

        table_fields.push(
          {
            key: "unpay_count",
            label: "未繳期數"
          },
          {
            key: "total_1",
            label: "未繳金額"
          },
        )

      }

      return table_fields;
    }
  },
  mounted() {
    this.businessInfoApi = new businessInfoApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.businessInfoApi.page);
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getDirectPushReturnPiece();
    },
    countNoNum,
    convertRocDate,
    // 查詢直推回歸件
    getDirectPushReturnPiece(pageIndex = null) {
      const params = {
        'class_detail': 1,
        'return': 1,
        'member_status': this.tab.tabIndex,
        'sales_ID_number': this.data.info.account,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.businessInfoApi.getDirectPushReturnPiece((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數

        this.data.table_data = res.data;
      }, params)
    },
    // 帳單處理(下載 OR 預覽)
    async billhandle(item = null, type = 'download') {
      this.data.billMode = type;
      this.status.resetDom = true;
      this.data.temp_table_data = Object.assign({}, item);

      if (type === 'download') this.status.pdfEnableDownload = true;
      else if (type === 'preview') this.status.pdfEnableDownload = false;

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 帳單處理完成
    billhandlerCompleted() {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();

      if (this.data.billMode === 'preview') this.status.previewBillModal = true;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/returnPiece.vue